import React, { useEffect, useMemo, useState } from "react";
import { VehicleTableRow } from "../../VehicleTableRow";
import {Paginate} from "../../Paginate";
import CreditsTable from "./CreditsTable";
import useCredits from "../../../Global/Api/Settings/credits.api";
import "./index.scss";
import {useSelector} from "react-redux";

export default function Credits() {
    const [page, setPage] = useState(1);
    const { credits, get } = useCredits(page, 10);
    const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);

    useEffect(() => {
        get();
    }, [page]);

    const renderFaq = useMemo(
        () =>
                <CreditsTable data={credits?.data} />,
        [credits]
    );

    return (
        <div className="credits">
            <div className="credits_title">
               <h3>Tokens</h3>
                <p>Total Amount Available: <strong>{accountData?.country_currency_sign}{credits?.credits}</strong></p>
            </div>
            <div className="credits_table">{renderFaq}</div>
            {credits?.totalPage > 1 && (
                <Paginate currentPage={page} setCurrentPage={setPage} pageCount={credits?.totalPage}/>
            )}
        </div>
    );
}
